import React, { useState, useRef } from 'react';
import { Card, Button, Form, Dimmer } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import PutObject from '../../lib/putObject';
import { toBase64 } from '../../lib/helpers';

const ProductEditModal = ({ recordId, closeMainModal, reload }) => {
  const { data, loading, handleChange } = useFetch(`products/${recordId}`);
  const [saveLoading, toggleSaveLoading] = useState(false)
  const photoFile = useRef(null)

  const saveEdit = async () => {
    const editedProduct = {
      _id: recordId,
      productData: {
        name: data.name,
        price: data.price,
        productUrl: data.productUrl,
        description: data.description
      }
    }

    if (photoFile.current.files.length > 0 && photoFile.current.files[0].type.includes('image'))
      editedProduct.productData.image = await toBase64(photoFile.current.files[0])

    toggleSaveLoading(true)
    PutObject('products', editedProduct).then(() => {
      toggleSaveLoading(false)
      if (typeof reload === 'function') {
        reload()
      }
      closeMainModal()
    });
  }

  return (
    <Card>
      <Dimmer active={loading} loader={loading}>
        <Card.Header>
          <Card.Title>Edit Product</Card.Title>
          <Card.Options>
            <Button size="sm" icon="x" onClick={() => closeMainModal()} />
          </Card.Options>
        </Card.Header>
        {!loading && data &&
          <Card.Body>
            <Form>
              <Form.Input
                name='name'
                label='Name'
                placeholder=''
                value={data['name']}
                onChange={handleChange}
              />

              <Form.Textarea
                name='description'
                label='description'
                placeholder=''
                value={data['description']}
                onChange={handleChange}
              />

              <Form.Input
                name='price'
                label='price'
                type="number"
                min="0"
                value={data['price']}
                onChange={handleChange}
              />

              <Form.Input
                name='productUrl'
                label='URL'
                placeholder=''
                value={data['productUrl']}
                onChange={handleChange}
              />

              <Form.Label>Photo</Form.Label>
              <input type='file' ref={photoFile} />
            </Form>
          </Card.Body>
        }

        <Card.Footer>
          <div style={{ textAlign: 'right' }}>
            <Button
              color="primary"
              size="sm"
              className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
              onClick={saveEdit}
              disabled={saveLoading}
            >
              Edit
            </Button>
          </div>
        </Card.Footer>
      </Dimmer>
    </Card>
  )
}

export default ProductEditModal;